import { render, staticRenderFns } from "./tradeuploaderror-list.vue?vue&type=template&id=72ef7d82&"
import script from "./tradeuploaderror-list.vue?vue&type=script&lang=js&"
export * from "./tradeuploaderror-list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "tradeuploaderror-list.vue"
export default component.exports